import fetcher from 'api/fetcher';
import { push } from 'connected-react-router';

import { InvoicePayerType } from 'store/models/invoices';
import { resetCreatePayerInfo, setPayerErrors } from 'store/models/payerCreate';

const makePayer = (setLoad) => {
    return (dispatch, getState) => {
        setLoad(true);
        const {
            payerType,
            payerLegalName,
            payerINN,
            payerKPP,
            payerLegalAddress,
            payerDocAddress,
            payerName,
            payerUserId,
        } = getState().payerCreate;
        let body = {};
        switch (payerType) {
            case InvoicePayerType.Legal:
                body = {
                    payerType,
                    title: payerLegalName,
                    inn: payerINN,
                    kpp: payerKPP,
                    address: payerLegalAddress,
                    post: payerDocAddress,
                };
                break;
            case InvoicePayerType.Individual:
                body = {
                    payerType,
                    title: payerLegalName,
                    inn: payerINN,
                    address: payerLegalAddress,
                    post: payerDocAddress,
                };
                break;
            case InvoicePayerType.Natural:
                body = {
                    payerType,
                    fio: payerName,
                };
                break;
        }
        body.userId = payerUserId;
        fetcher
            .post('/api/v1/backoffice/payers/', body)
            .then(({ id }) => {
                dispatch(resetCreatePayerInfo());
                dispatch(push(`/new/admin/payers/${id}`));
            })
            .catch((err) => {
                if (err?.response?.status === 400) {
                    dispatch(setPayerErrors(err.response.data));
                }
                setLoad(false);
            });
    };
};

export default makePayer;
